/* Sleebo Nuit — starfield, 5-zone diagram, product options */
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Starfield ---------- */
  document.querySelectorAll('canvas.sn-stars').forEach(function(cv){
    var ctx = cv.getContext('2d'), stars = [];
    function size(){
      var r = cv.getBoundingClientRect(); if (!r.width) return;
      var d = Math.min(window.devicePixelRatio || 1, 2);
      cv.width = r.width * d; cv.height = r.height * d; ctx.setTransform(d,0,0,d,0,0);
      stars = [];
      var n = Math.round(r.width * r.height / 2600);
      for (var i = 0; i < n; i++) stars.push({x:Math.random()*r.width, y:Math.random()*r.height, r:Math.random()*1.2+.2, p:Math.random()*6.28, s:Math.random()*.02+.004});
      draw(0);
    }
    function draw(t){
      var r = cv.getBoundingClientRect();
      ctx.clearRect(0,0,r.width,r.height);
      for (var i = 0; i < stars.length; i++){
        var s = stars[i];
        ctx.globalAlpha = reduce ? .7 : .45 + .45*Math.sin(s.p + t*s.s);
        ctx.fillStyle = '#EDE6D3'; ctx.beginPath(); ctx.arc(s.x, s.y, s.r, 0, 6.283); ctx.fill();
      }
      ctx.globalAlpha = 1;
    }
    size(); window.addEventListener('resize', size);
    if (!reduce){
      var visible = true;
      if ('IntersectionObserver' in window) new IntersectionObserver(function(e){ visible = e[0].isIntersecting; }).observe(cv);
      (function loop(ts){ if (visible) draw(ts/16); requestAnimationFrame(loop); })(0);
    }
  });

  /* ---------- 5 zones ---------- */
  document.querySelectorAll('[data-sn-zones]').forEach(function(root){
    var btns = root.querySelectorAll('.sn-zone-list button');
    function set(z){
      btns.forEach(function(b){ b.setAttribute('aria-pressed', b.dataset.zone === z ? 'true' : 'false'); });
      root.querySelectorAll('.sn-zone-shape').forEach(function(s){ s.classList.toggle('on', s.dataset.zone === z); });
      root.querySelectorAll('.sn-hot').forEach(function(h){ h.classList.toggle('on', h.dataset.zone === z); });
    }
    btns.forEach(function(b){ b.addEventListener('click', function(){ set(b.dataset.zone); }); });
    root.querySelectorAll('.sn-hot').forEach(function(h){ h.addEventListener('click', function(){ set(h.dataset.zone); }); });
    set('1');
  });

  /* ---------- Delivery estimate: 1–2 business days of preparation + 11–14 of transit = 12–16 ---------- */
  var months = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];
  function addBusinessDays(d, n){ var r = new Date(d); while (n > 0){ r.setDate(r.getDate()+1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; } return r; }
  var a = addBusinessDays(new Date(), 12), b = addBusinessDays(new Date(), 16);
  document.querySelectorAll('[data-sn-d1]').forEach(function(el){ el.textContent = a.getDate() + ' ' + months[a.getMonth()]; });
  document.querySelectorAll('[data-sn-d2]').forEach(function(el){ el.textContent = b.getDate() + ' ' + months[b.getMonth()]; });

  /* ---------- Product ---------- */
  document.querySelectorAll('[data-sn-product]').forEach(function(root){
    var data = JSON.parse(root.querySelector('script[data-sn-json]').textContent);
    var money = function(cents){ return (cents/100).toFixed(2).replace('.', ',') + ' €'; };
    var idInput = root.querySelector('input[name="id"]'), qtyInput = root.querySelector('input[name="quantity"]');
    var addBtn = root.querySelector('[data-sn-add]'), main = root.querySelector('[data-sn-main]');
    var state = { variant: data.variants.filter(function(v){ return v.id === data.selected; })[0] || data.variants[0], q: 1 };

    function showMedia(id){
      var m = data.media.filter(function(x){ return x.id === id; })[0]; if (!m || !main) return;
      main.src = m.src; main.srcset = m.srcset; main.alt = m.alt;
      root.querySelectorAll('.sn-thumbs button').forEach(function(t){ t.setAttribute('aria-pressed', +t.dataset.media === id ? 'true' : 'false'); });
    }
    root.querySelectorAll('.sn-thumbs button').forEach(function(t){ t.addEventListener('click', function(){ showMedia(+t.dataset.media); }); });

    function render(){
      var v = state.variant, q = state.q, pct = data.tiers[q] || 0;
      /* Shopify arrondit la remise automatique à l'inférieur, oreiller par oreiller */
      var full = v.price * q, now = (v.price - Math.floor(v.price * pct / 100)) * q;
      idInput.value = v.id; qtyInput.value = q;
      root.querySelectorAll('[data-sn-now]').forEach(function(el){ el.textContent = money(now); });
      var was = root.querySelector('[data-sn-was]'), save = root.querySelector('[data-sn-save]');
      if (q > 1){ was.hidden = false; save.hidden = false; was.textContent = money(full); save.textContent = 'Économie ' + money(full - now); }
      else { was.hidden = true; save.hidden = true; }
      var c = root.querySelector('[data-sn-color]'); if (c) c.textContent = v.title;
      addBtn.disabled = !v.available;
      addBtn.querySelector('[data-sn-label]').textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
      if (window.history.replaceState){ var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); }
    }
    root.querySelectorAll('.sn-sw').forEach(function(sw){
      sw.addEventListener('click', function(){
        state.variant = data.variants.filter(function(v){ return v.id === +sw.dataset.variant; })[0];
        root.querySelectorAll('.sn-sw').forEach(function(o){ o.setAttribute('aria-pressed', o === sw ? 'true' : 'false'); });
        if (state.variant.media) showMedia(state.variant.media);
        render();
      });
    });
    root.querySelectorAll('.sn-bd').forEach(function(bd){
      bd.addEventListener('click', function(){
        state.q = +bd.dataset.q;
        root.querySelectorAll('.sn-bd').forEach(function(o){ o.setAttribute('aria-pressed', o === bd ? 'true' : 'false'); });
        render();
      });
    });
    if (state.variant.media) showMedia(state.variant.media); else if (data.media[0]) showMedia(data.media[0].id);
    render();
  });
})();